const initPage = () => {
  const jobSeekerProfileItems = $(".job-seeker-profile-item");
  if (!jobSeekerProfileItems.length) {
    return;
  }

  jobSeekerProfileItems.click(function(e){
    if (e.target.tagName === 'A') return;

    $('.job-seeker-profile-details-link', $(this)).get(0).click();
  });
};

$(initPage);
